import { render, staticRenderFns } from "./role.vue?vue&type=template&id=7e812fbb&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=7e812fbb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e812fbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e812fbb')) {
      api.createRecord('7e812fbb', component.options)
    } else {
      api.reload('7e812fbb', component.options)
    }
    module.hot.accept("./role.vue?vue&type=template&id=7e812fbb&scoped=true", function () {
      api.rerender('7e812fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/role.vue"
export default component.exports